import * as React from 'react';

import Box from '@mui/material/Box';

export default function NotFound() {
   return (
      <Box>Not Found</Box>
   )
}